// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"614":"component---src-pages-editor-js","712":"component---src-templates-storyblok-entry-tsx"}[chunkId] || chunkId) + "-" + {"454":"408c1acffd4919854027","614":"cb454a734192243bc63f","712":"ad9ab27817b6a82fe256"}[chunkId] + ".js";
};